export default "__VITE_ASSET__CDAjf$RQ__"